import { LocationState } from '../interfaces/interfaces';

// eslint-disable-next-line @typescript-eslint/no-inferrable-types
const googleAutoCompleteAddressType: string = 'address'; // this is not for production

// TODO: UNIT TEST
// find propertyId (guid or similar) in path
export function getPropertyIdFromUrl(path: LocationState): string | undefined {
	const pathSections: Array<string> = path.pathname.split('/');
	return pathSections?.[3];
}

export function getPropertyAddressFromUrl(path: LocationState): string | undefined {
	const pathSections: Array<string> = path.pathname.split('/');
	return pathSections[2] ?? '';
}

// TODO: UNIT TEST possibly remove
export default function determineRoute(locationAddress: string, filtersPriceMin: string, filtersPriceMax: string) {
	let route = '';

	if (locationAddress) route += urlifyLocation(locationAddress);
	if (filtersPriceMin || filtersPriceMax) route += urlifyFilters(filtersPriceMin, filtersPriceMax);

	if (route) return route;
	else return '';
}

function urlifyLocation(locationInput = '') {
	switch (googleAutoCompleteAddressType) {
		case 'address':
			if (locationInput?.length > 0) {
				locationInput = `/home-address/${encodeURIComponent(prepareStringForUrl(locationInput))}`;
			}
			break;

		case 'zip':
			locationInput = '';
			break;
	}

	if (locationInput) return locationInput;
}

function urlifyFilters(filtersPriceMin: string, filtersPriceMax: string) {
	let filtersString = '';

	if (filtersPriceMin) {
		filtersString += `pricemin=${filtersPriceMin}`;
	}
	if (filtersPriceMax) {
		filtersString += `pricemax=${filtersPriceMax}`;
	}

	if (filtersString) return `/filters-${prepareStringForUrl(filtersString)}`;
}

const prepareStringForUrl = (inputString: string) => {
	return inputString.replaceAll(' ', '-');
};
